// import Vue from "vue";

const getDefaultState = () => {
  return {
    workspace: null,
    workspaceConfig: null,
    workspaceViews: null,
    workspaceProperties: null,
    sidebar: {
      sections: null,
    },
  };
};

const state = getDefaultState();

// Synchronous
const mutations = {
  RESET_STATE(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState());
  },

  SET_WORKSPACE_DATA(state, workspaceData) {
    /* Set workspace */
    state.workspace = workspaceData.workspace;

    /* Set workspace config */
    state.workspaceConfig = workspaceData.workspaceConfig;

    /* Set workspace views */
    state.workspaceViews = workspaceData.workspaceViews;

    /* Set workspace's properties */
    state.workspaceProperties = workspaceData.workspaceProperties;

    /* Set workspace sidebar sections */
    state.sidebar.sections = workspaceData.sidebarSections;
  },
};

// Asynchronous
const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },

  setWorkspaceData({ commit }, workspaceData) {
    commit("SET_WORKSPACE_DATA", workspaceData);
  },
};

const workspace = {
  namespaced: true,

  state,
  mutations,
  actions,
};

export default workspace;
